//
//  color palettes from D3
//  see https://observablehq.com/@d3/color-schemes
//
export default [
  {
    name: 'brownGreen',
    colors: [
      '#543005',
      '#7c480a',
      '#a1661b',
      '#c28c3d',
      '#d9b671',
      '#ebd7a4',
      '#f4ead0',
      '#eef1ea',
      '#d2ece8',
      '#a8ddd5',
      '#75c3b8',
      '#429f96',
      '#197b73',
      '#045a51',
      '#003c30',
    ],
    id: 'interpolateBrBG',
    isPrimary: true,
    type: 'd3',
  },
  {
    name: 'greys',
    colors: [
      '#ffffff',
      '#f6f6f6',
      '#ececec',
      '#dfdfdf',
      '#d1d1d1',
      '#c0c0c0',
      '#acacac',
      '#979797',
      '#828282',
      '#6e6e6e',
      '#5b5b5b',
      '#444444',
      '#2c2c2c',
      '#151515',
      '#000000',
    ],
    id: 'interpolateGreys',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'inferno',
    colors: [
      '#000004',
      '#0d0829',
      '#280b53',
      '#470b6a',
      '#65156e',
      '#82206c',
      '#9f2a63',
      '#bc3754',
      '#d44842',
      '#e8602d',
      '#f57d15',
      '#fc9f07',
      '#fac228',
      '#f3e55d',
      '#fcffa4',
    ],
    id: 'interpolateInferno',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'magma',
    colors: [
      '#000004',
      '#0c0926',
      '#221150',
      '#400f74',
      '#5f187f',
      '#7b2382',
      '#982d80',
      '#b73779',
      '#d3436e',
      '#eb5760',
      '#f8765c',
      '#fd9a6a',
      '#febb81',
      '#fddc9e',
      '#fcfdbf',
    ],
    id: 'interpolateMagma',
    isPrimary: true,
    type: 'd3',
  },
  {
    name: 'plasma',
    colors: [
      '#0d0887',
      '#350498',
      '#5302a3',
      '#6f00a8',
      '#8b0aa5',
      '#a31e9a',
      '#b83289',
      '#cc4778',
      '#db5c68',
      '#e97158',
      '#f48849',
      '#fba238',
      '#febd2a',
      '#fada24',
      '#f0f921',
    ],
    id: 'interpolatePlasma',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'puBuGn',
    colors: [
      '#fff7fb',
      '#f4ebf5',
      '#e7e0ef',
      '#d7d6e9',
      '#c3cbe3',
      '#aac0dc',
      '#8bb4d6',
      '#69a8cf',
      '#4b9bc5',
      '#2e8fb4',
      '#14859a',
      '#057b7c',
      '#016d61',
      '#015b4a',
      '#014636',
    ],
    id: 'interpolatePuBuGn',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'rainbow',
    colors: [
      '#6e40aa',
      '#a83cb3',
      '#df40a1',
      '#ff507a',
      '#ff704e',
      '#f89b31',
      '#d2c934',
      '#aff05b',
      '#6bf75c',
      '#34f07e',
      '#1bd9ac',
      '#1fb3d3',
      '#3988e1',
      '#585fd2',
      '#6e40aa',
    ],
    id: 'interpolateRainbow',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'RedPurple',
    colors: [
      '#fff7f3',
      '#feeae6',
      '#fddcd8',
      '#fcccc9',
      '#fbb9be',
      '#faa3b6',
      '#f887ac',
      '#f369a3',
      '#e74a9b',
      '#d42d92',
      '#bb1386',
      '#9f047d',
      '#820177',
      '#650171',
      '#49006a',
    ],
    id: 'interpolateRdPu',
    isPrimary: true,
    type: 'd3',
  },
  {
    name: 'sinebow',
    colors: [
      '#ff4040',
      '#f27616',
      '#cfae01',
      '#9cdd06',
      '#63f922',
      '#30fe51',
      '#0de989',
      '#00bfbf',
      '#0d89e9',
      '#3051fe',
      '#6322f9',
      '#9c06dd',
      '#cf01ae',
      '#f21676',
      '#ff4040',
    ],
    id: 'interpolateSinebow',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'spectral',
    colors: [
      '#9e0142',
      '#c42c4a',
      '#e1524a',
      '#f3784c',
      '#fba35e',
      '#fdca79',
      '#fee89a',
      '#fbf8b0',
      '#ebf7a6',
      '#ccea9f',
      '#a0d9a3',
      '#72c3a7',
      '#4ba0b1',
      '#4478b2',
      '#5e4fa2',
    ],
    id: 'interpolateSpectral',
    isPrimary: true,
    type: 'd3',
  },
  {
    name: 'turbo',
    colors: [
      '#23171b',
      '#4a44bc',
      '#4076f5',
      '#2ca6f1',
      '#26d0cd',
      '#37ed9f',
      '#5ffc73',
      '#95fb51',
      '#cbe839',
      '#f5c72b',
      '#ff9b21',
      '#fb6919',
      '#d6390f',
      '#a81604',
      '#900c00',
    ],
    id: 'interpolateTurbo',
    isPrimary: true,
    type: 'd3',
  },
  {
    name: 'viridis',
    colors: [
      '#440154',
      '#481b6d',
      '#46327e',
      '#3f4788',
      '#365c8d',
      '#2e6e8e',
      '#277f8e',
      '#21918c',
      '#1fa187',
      '#2db27d',
      '#4ac16d',
      '#73d056',
      '#a0da39',
      '#d0e11c',
      '#fde725',
    ],
    id: 'interpolateViridis',
    isPrimary: true,
    type: 'd3',
  },
  {
    name: 'YlGnBu',
    colors: [
      '#ffffd9',
      '#f4fbc3',
      '#e5f5b6',
      '#d0ecb4',
      '#b0e0b6',
      '#8ad2ba',
      '#65c3bf',
      '#45b4c2',
      '#2ea0c1',
      '#2288ba',
      '#216daf',
      '#2353a2',
      '#213c93',
      '#182b79',
      '#081d58',
    ],
    id: 'interpolateYlGnBu',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'YlOrBr',
    colors: [
      '#ffffe5',
      '#ffface',
      '#fff3b6',
      '#fee89c',
      '#fed97d',
      '#fec75b',
      '#feb140',
      '#fb992c',
      '#f3821d',
      '#e66b12',
      '#d45708',
      '#bc4604',
      '#a03804',
      '#832e05',
      '#662506',
    ],
    id: 'interpolateYlOrBr',
    isPrimary: true,
    type: 'd3',
  },
  {
    name: 'YlOrRd',
    colors: [
      '#ffffcc',
      '#fff5b3',
      '#ffea9a',
      '#fede82',
      '#fecd6a',
      '#feb855',
      '#fea246',
      '#fd893c',
      '#fc6932',
      '#f64828',
      '#e92a21',
      '#d71420',
      '#c00624',
      '#a20126',
      '#800026',
    ],
    id: 'interpolateYlOrRd',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'blueGreen',
    colors: [
      '#f7fcfd',
      '#ecf8fa',
      '#e1f3f5',
      '#d2eeeb',
      '#bce6dd',
      '#a0dbcc',
      '#83cfb9',
      '#68c2a3',
      '#51b68a',
      '#3da76f',
      '#2b9554',
      '#19833f',
      '#097030',
      '#015b25',
      '#00441b',
    ],
    id: 'interpolateBuGn',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'bluePurple',
    colors: [
      '#f7fcfd',
      '#eaf3f8',
      '#dae7f1',
      '#c8daea',
      '#b6cce3',
      '#a4bedb',
      '#97abd1',
      '#8f95c6',
      '#8c7dba',
      '#8b65ae',
      '#894da2',
      '#863293',
      '#7d1a7f',
      '#690a67',
      '#4d004b',
    ],
    id: 'interpolateBuPu',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'cividis',
    colors: [
      '#002051',
      '#032d66',
      '#173a6d',
      '#30476e',
      '#48546d',
      '#5d616e',
      '#706e71',
      '#7f7c75',
      '#8e8978',
      '#9e9878',
      '#b1a775',
      '#c6b76c',
      '#ddc75f',
      '#f1d851',
      '#fdea45',
    ],
    id: 'interpolateCividis',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'cool',
    colors: [
      '#6e40aa',
      '#654ec0',
      '#585fd2',
      '#4973dd',
      '#3988e1',
      '#2b9ede',
      '#1fb3d3',
      '#1ac7c2',
      '#1bd9ac',
      '#24e695',
      '#34f07e',
      '#4df56a',
      '#6bf75c',
      '#8cf457',
      '#aff05b',
    ],
    id: 'interpolateCool',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'cubeHelix',
    colors: [
      '#000000',
      '#170d22',
      '#1a2442',
      '#15434f',
      '#1b6145',
      '#387434',
      '#6a7b30',
      '#a07949',
      '#c77b7b',
      '#d588b5',
      '#cda3e1',
      '#c2c4f3',
      '#c6e1f1',
      '#def4ef',
      '#ffffff',
    ],
    id: 'interpolateCubehelixDefault',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'greenBlue',
    colors: [
      '#f7fcf0',
      '#eaf7e4',
      '#ddf2d8',
      '#d1edcc',
      '#c1e7c1',
      '#acdfbb',
      '#94d6bc',
      '#7bcbc4',
      '#62bdcb',
      '#4aaccc',
      '#3597c4',
      '#2182b9',
      '#116dac',
      '#095799',
      '#084081',
    ],
    id: 'interpolateGnBu',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'orangeRed',
    colors: [
      '#fff7ec',
      '#feeed7',
      '#fee5c1',
      '#fdd9ab',
      '#fdcc97',
      '#fdbc86',
      '#fca771',
      '#fa8e5d',
      '#f4764f',
      '#ea5c40',
      '#dd3f2b',
      '#cc2317',
      '#b60c08',
      '#9c0101',
      '#7f0000',
    ],
    id: 'interpolateOrRd',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'purpleBlue',
    colors: [
      '#fff7fb',
      '#f4eef6',
      '#e7e3f0',
      '#d7d7e9',
      '#c3cbe3',
      '#abc0dc',
      '#90b4d6',
      '#72a8cf',
      '#519ac6',
      '#308bbe',
      '#167ab3',
      '#086aa5',
      '#045c90',
      '#034b76',
      '#023858',
    ],
    id: 'interpolatePuBu',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'purpleRed',
    colors: [
      '#f7f4f9',
      '#eee8f3',
      '#e4d9eb',
      '#dac5e0',
      '#d1afd5',
      '#ce98c9',
      '#d37fbd',
      '#dd63ae',
      '#e2449a',
      '#e02a81',
      '#d31967',
      '#bd0d53',
      '#a00444',
      '#830133',
      '#67001f',
    ],
    id: 'interpolatePuRd',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'RdBu',
    colors: [
      '#67001f',
      '#9a1429',
      '#c0383b',
      '#da6a57',
      '#ee9a7c',
      '#f8c3a9',
      '#fae1d3',
      '#f2efee',
      '#dae9f1',
      '#b5d7e8',
      '#85bcd9',
      '#539bc7',
      '#3079b4',
      '#195693',
      '#053061',
    ],
    id: 'interpolateRdBu',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'warm',
    colors: [
      '#6e40aa',
      '#8a3eb2',
      '#a83cb3',
      '#c53dad',
      '#df40a1',
      '#f4468f',
      '#ff507a',
      '#ff5e63',
      '#ff704e',
      '#ff843d',
      '#f89b31',
      '#e6b32e',
      '#d2c934',
      '#bfde43',
      '#aff05b',
    ],
    id: 'interpolateWarm',
    isPrimary: false,
    type: 'd3',
  },
  {
    name: 'YlGn',
    colors: [
      '#ffffe5',
      '#fafdcd',
      '#f0f9b8',
      '#e1f3a9',
      '#ccea9d',
      '#b2df91',
      '#96d385',
      '#78c578',
      '#59b669',
      '#3fa45a',
      '#2b904b',
      '#197d40',
      '#096b39',
      '#015931',
      '#004529',
    ],
    id: 'interpolateYlGn',
    isPrimary: false,
    type: 'd3',
  },
];
